import React from 'react'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

const BackButton: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="flex w-full px-4">
      <button
        className="text-darkBlue font-semibold flex flex-row gap-2 items-center p-2"
        onClick={() => navigate('/')}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
        <span className="pt-1"> Tillbaka till översikt</span>
      </button>
    </div>
  )
}

export default BackButton
